import { FlightsClassTypes, FlightSortOptions } from 'constants/flight'

export enum FlightsFiltersPriceType {
  ADULT = 'adult',
  TOTAL = 'total'
}

export interface FlightsFiltersValues {
  stops: Array<string>;
  airlines: Array<string>;
  cabinTypes: Array<string>;
  carriers: Array<string>;
  stopDurations?: string;
  durations?: string;
  minPrices?: string;
  maxPrices?: string;
  minDepartureTime?: string;
  maxDepartureTime?: string;
  minArrivalTime?: string;
  maxArrivalTime?: string;
  priceFilterType: FlightsFiltersPriceType;
  recommended: Array<string>;
  bags: Array<string>;
  stopOverCities: Array<string>;
  alliances: Array<string>;
  sort?: FlightSortOptions;
  originAirportCode?: string;
  destinationAirportCode?: string;
  departDate?: string;
  returnDate?: string;
  fareClass?: FlightsClassTypes;
}

export enum FlightsFiltersBagType {
  CARRY_ON = 'carryOn',
  CHECKED = 'checked',
}

export enum FlightsFiltersRecommendedType {
  DIRECT_FLIGHTS = 'directFlights',
  INCLUDES_CHECKED_BAG = 'includesCheckedBag'
}
